import React from 'react';
import { Mail, MapPin, Instagram, Twitter, Linkedin } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-gray-50 border-t border-gray-100 py-4 sm:py-6" data-id="element-107">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8" data-id="element-108">
        <div className="flex flex-col sm:flex-row justify-between items-center" data-id="element-109">
          <div className="flex items-center mb-3 sm:mb-0" data-id="element-110">
            <div className="mr-1.5 h-5 w-0.5 bg-gradient-to-b from-blue-600 to-blue-400 rounded-full" data-id="element-111"></div>
            <span className="text-lg font-bold bg-gradient-to-r from-blue-600 to-blue-400 bg-clip-text text-transparent" data-id="element-112">
              MINGA
            </span>
          </div>

          <div className="flex flex-col sm:flex-row sm:items-center text-xs sm:text-sm text-gray-500 mb-3 sm:mb-0 space-y-1 sm:space-y-0" data-id="element-113">
            <div className="flex items-center sm:mr-6 justify-center" data-id="element-114">
              <MapPin className="h-3 w-3 sm:h-4 sm:w-4 text-blue-500 mr-1" data-id="element-115" />
              <span data-id="element-116">Santiago, Chile</span>
            </div>
            <div className="flex items-center justify-center" data-id="element-117">
              <Mail className="h-3 w-3 sm:h-4 sm:w-4 text-blue-500 mr-1" data-id="element-118" />
              <a href="mailto:hola@somosminga.com" className="hover:text-blue-600 transition-colors" data-id="element-119">
                hola@somosminga.com
              </a>
            </div>
          </div>

          <div className="flex space-x-3 sm:space-x-4" data-id="element-120">
            <a href="#" className="text-gray-400 hover:text-blue-500 transition-colors" data-id="element-121">
              <Instagram className="h-4 w-4 sm:h-5 sm:w-5" data-id="element-122" />
              <span className="sr-only" data-id="element-123">Instagram</span>
            </a>
            <a href="#" className="text-gray-400 hover:text-blue-500 transition-colors" data-id="element-124">
              <Twitter className="h-4 w-4 sm:h-5 sm:w-5" data-id="element-125" />
              <span className="sr-only" data-id="element-126">Twitter</span>
            </a>
            <a href="#" className="text-gray-400 hover:text-blue-500 transition-colors" data-id="element-127">
              <Linkedin className="h-4 w-4 sm:h-5 sm:w-5" data-id="element-128" />
              <span className="sr-only" data-id="element-129">LinkedIn</span>
            </a>
          </div>
        </div>

        <div className="mt-2 sm:mt-4 pt-2 sm:pt-4 border-t border-gray-200 flex flex-col sm:flex-row justify-between items-center text-2xs sm:text-xs text-gray-400" data-id="element-130">
          <p data-id="element-131">&copy; {new Date().getFullYear()} MINGA. Todos los derechos reservados.</p>
          <div className="mt-1 sm:mt-0 flex space-x-3 sm:space-x-4" data-id="element-132">
            <a href="#" className="hover:text-blue-500 transition-colors" data-id="element-133">Términos</a>
            <a href="#" className="hover:text-blue-500 transition-colors" data-id="element-134">Privacidad</a>
          </div>
        </div>
      </div>
    </footer>;
};